export default __webpack_public_path__ + "static/media/img-guide-gt-popup-3-se_se@2x.7d36f456.png";